declare global {
  interface Window {
    TsMasterSpot: (data: any, retry?: number) => void;
    NativeAd: (data: any, retry?: number) => void;
    adnLoaded: any;
  }
}

const RETRY_LIMIT = 5;
const TIMEOUT = 1000;

export const initTsMasterSpot = () => {
  window.TsMasterSpot = (data, retry) => {
    const retryValue = retry || 1;

    if (retryValue > RETRY_LIMIT) {
      return;
    }

    setTimeout(() => {
      console.debug("[ads] TsMasterSpot didn't load. Waiting", retryValue);
      // eslint-disable-next-line
      window.TsMasterSpot(data, retryValue + 1);
    }, TIMEOUT);
  };
};

export const initNativeAd = () => {
  window.NativeAd = (data, retry) => {
    const retryValue = retry || 1;

    if (retryValue > RETRY_LIMIT) {
      return;
    }

    setTimeout(() => {
      console.debug("[ads] NativeAd didn't load. Waiting", retryValue);
      // eslint-disable-next-line
      window.NativeAd(data, retryValue + 1);
    }, TIMEOUT);
  };
};

export const resetAdn = () => {
  window.adnLoaded = [];
};
